module.exports = __webpack_public_path__ + "static/careers-0d619996fbfd8d1adca54ad0901478db.mp4";